import React from "react";
import { Container } from "./styles";
export const PianoTooltipDisplay = ({
  message
}) => /*#__PURE__*/React.createElement(Container, {
  dangerouslySetInnerHTML: {
    __html: message
  },
  "data-qa": "piano-tooltip-display"
});
PianoTooltipDisplay.displayName = "PianoTooltipDisplay";